import React from 'react';
import Profile from './profile';
import { Table, Button } from 'react-bootstrap';
import history from '../../assets/images/profile/history-red.svg';
import singelgem from '../../assets/images/header/gem.png';
import nexticon from '../../assets/images/profile/arrow.svg';
import previcon from '../../assets/images/profile/arrow.svg';

const BetHistory = () => {
  const item = 10;

  return (
    <Profile>
      <div className='bet-history'>
        <div className='page-heading'>
          <h3>
            <img src={history} alt='' /> Bet History
          </h3>
        </div>

        <div className='bet-history-content'>
          <Table striped bordered variant='dark' responsive>
            <thead>
              <tr>
                <th>Game</th>
                <th>Time</th>
                <th>Wagered </th>
                <th>Multiplier</th>
                <th>Profit</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(item)].map((index) => (
                <tr key={index}>
                  <td>Roulette</td>
                  <td>4:09 PM</td>
                  <td>
                    <div className='transaction-value'>
                      <img src={singelgem} alt='' /> $259.25
                    </div>
                  </td>
                  <td>2.00x</td>
                  <td>
                    <div className='transaction-value'>
                      <img src={singelgem} alt='' /> $259.25
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className='pagination'>
            <Button className='disabled'>
              <img src={previcon} alt='' /> Previous Page
            </Button>

            <Button>
              Next Page <img src={nexticon} alt='' />
            </Button>
          </div>
        </div>
      </div>
    </Profile>
  );
};

export default BetHistory;
